import { TranslateService } from '@ngx-translate/core';

import { ISession, Session, SessionUser } from '../models/session';
import { AclService } from '../services/acl.service';

export const getSessionUserType = (
  sessionUser: SessionUser,
  hostsIDs: Set<string>,
  space: ISession | undefined,
  aclService: AclService,
  translateService: TranslateService,
): string => {
  if (!space) {
    return '';
  }

  if (sessionUser._id === space.owner) {
    return translateService.instant('Owner');
  }

  if (hostsIDs.has(sessionUser._id)) {
    if (Session.isUserEnabledAdminHost(sessionUser._id, space, aclService)) {
      return translateService.instant('Admin');
    }

    return translateService.instant('Host');
  }

  return translateService.instant('Participant');
};

export class SpaceUtils {
  public concatChunks(arrays: any[]): Uint8Array {
    if (arrays.length === 0) {
      return new Uint8Array(0);
    }
    // Get the total length of all arrays.
    let length = 0;
    arrays.forEach((item: string | any[]) => {
      length += item.length;
    });

    // Create a new array with total length and merge all source arrays.
    const mergedArray = new Uint8Array(length);
    let offset = 0;
    arrays.forEach((item) => {
      mergedArray.set(item, offset);
      offset += item.length;
    });
    return mergedArray;
  }
}
